import React, { Component, Fragment, useState } from "react";


import nilla from '../../assets/images/nilla.svg';
import { useNavigate } from "react-router";
import { useTranslation, I18nextProvider } from "react-i18next";

import { useCustomizeContext } from "../../context";

import { useEffect } from "react";

const Pagenotfound = (props) => {
   const { t, i18n } = useTranslation();
   let navigate = useNavigate();

   const {
      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   const navigateHome = () => {
      navigate("/");
   }

   useEffect(() => {
      setClassIsActive(false);
      document.body.classList.remove("SideMenuOpen");
   }, []);

   return (
      <Fragment>
         <section class="fout_04_sec">
            <div class="container">
               <div>
                  <div class="row align-items-center">
                     <div class="col-lg-6 order-lg-1 order-2">
                        <div class="pnf_1">
                           <h2>{t("Page Not Found")}</h2>
                           <p>{t("faqstatementpolicy")} </p>
                           <button onClick={navigateHome} class="btn">{t("Back to Home")} </button>
                        </div>
                     </div>
                     <div class="col-lg-6 order-lg-2 order-lg-1 ">
                        <div>
                           <img class="img-fluid" src={nilla} alt="" />
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         </section>
      </Fragment>
   );

}

export default Pagenotfound;